import _ from "lodash";

export default class SelectOption {
  static ERROR_NO_PROPERTY_MESSAGE = "This item don't have this property.";
  static ERROR_FUNCTION_PROPERTY_MESSAGE = "This property is function.";

  public readonly value: string;
  public readonly text: string;

  public constructor(item: any, valueKey: string, textKey: string = valueKey) {
    if (!item.hasOwnProperty(valueKey) || !item.hasOwnProperty(valueKey)) {
      throw new Error(SelectOption.ERROR_NO_PROPERTY_MESSAGE);
    }
    if (_.isFunction(item[valueKey])) {
      throw new Error(SelectOption.ERROR_FUNCTION_PROPERTY_MESSAGE);
    }
    this.value = String(item[valueKey]);
    this.text = String(item[textKey]);
  }
}
